module.exports = __webpack_public_path__ + "static/media/MuscoVision_logo-blue-grey.af91165b.svg";